import { useEffect, useRef, useState } from 'react';

export function useDebouncedValue<T>(value: T, wait: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const valueRef = useRef(value);

  useEffect(() => {
    valueRef.current = value;
    const timeout = setTimeout(() => {
      setDebouncedValue(valueRef.current);
    }, wait);

    return () => {
      clearTimeout(timeout);
    };
  }, [value, wait]);

  return debouncedValue;
}
